import { useEffect } from "react";
import { H2, P, UL } from "./legal";

/** Static cookie-policy page served at /polityka-cookies. */
export default function CookiePolicy() {
  useEffect(() => {
    document.title = "Polityka plików cookie — wycena.halavach.pl";
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="bg-brand text-white">
        <div className="max-w-3xl mx-auto px-6 py-10">
          <p className="text-sm uppercase tracking-widest opacity-70">Halavach Real Estate</p>
          <h1 className="mt-2 text-3xl md:text-4xl font-bold">Polityka plików cookie</h1>
          <p className="mt-2 opacity-80">Kalkulator wyceny nieruchomości wycena.halavach.pl</p>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10 pb-16">
        <H2>1. Czym są pliki cookie?</H2>
        <P>
          Pliki cookie to małe pliki tekstowe, które są umieszczane na Twoim komputerze lub
          urządzeniu mobilnym podczas odwiedzania naszej strony internetowej. Są powszechnie
          używane, aby strony internetowe działały bardziej efektywnie i dostarczały
          informacje właścicielom stron.
        </P>

        <H2>2. Jak używamy plików cookie</H2>
        <P>Używamy plików cookie, aby:</P>
        <UL
          items={[
            "Zapamiętywać Twoje preferencje i ustawienia",
            "Rozumieć, jak korzystasz z naszej strony internetowej",
            "Poprawiać wydajność naszej strony internetowej",
            "Dostarczać spersonalizowane treści i reklamy",
          ]}
        />

        <H2>3. Rodzaje plików cookie, których używamy</H2>
        <P>
          <strong>Niezbędne pliki cookie</strong>
          <br />
          Te pliki cookie są niezbędne do prawidłowego funkcjonowania strony internetowej.
          Umożliwiają podstawowe funkcje, takie jak nawigacja po stronach, dostęp do
          bezpiecznych obszarów i zapamiętywanie Twoich preferencji.
        </P>
        <P>
          <strong>Pliki cookie analityczne</strong>
          <br />
          Te pliki cookie pomagają nam zrozumieć, jak odwiedzający wchodzą w interakcję
          z naszą stroną internetową, zbierając i raportując informacje anonimowo.
        </P>
        <P>
          <strong>Pliki cookie reklamowe</strong>
          <br />
          Te pliki cookie są używane do dostarczania reklam bardziej odpowiednich dla Ciebie
          i Twoich zainteresowań.
        </P>

        <H2>4. Zarządzanie plikami cookie</H2>
        <P>
          Możesz kontrolować i/lub usuwać pliki cookie według własnego uznania. Możesz usunąć
          wszystkie pliki cookie, które są już na Twoim komputerze, i możesz ustawić większość
          przeglądarek, aby zapobiec ich umieszczaniu.
        </P>
        <P>
          Swoje preferencje dotyczące plików cookie na naszej stronie możesz zmienić w każdej
          chwili, korzystając z opcji „Ustawienia plików cookie” w stopce strony.
        </P>

        <H2>5. Skontaktuj się z nami</H2>
        <P>
          Jeśli masz jakiekolwiek pytania dotyczące naszego używania plików cookie,
          skontaktuj się z nami pod adresem info@halavach.pl
        </P>

        <div className="mt-12">
          <a href="/" className="text-brand underline font-medium">
            ← Wróć do wyceny
          </a>
        </div>
      </main>
    </div>
  );
}
